import { gql, useMutation } from "@apollo/client";

const DELETE_DESIGNER_ACCOUNT_MUTATION = gql`
  mutation DeleteDesignerAccount($designerId: ID!) {
    deleteDesignerAccount(designerId: $designerId)
  }
`;

export const useDeleteDesignerAccountMutation = () => {
  const [deleteDesignerAccountMutation, { loading, error, data }] = useMutation(
    DELETE_DESIGNER_ACCOUNT_MUTATION
  );

  const deleteDesignerAccount = async (designerId: string) => {
    try {
      const { data } = await deleteDesignerAccountMutation({
        variables: { designerId },
      });
      return data?.deleteDesignerAccount;
    } catch (error) {
      console.error("Error deleting designer account:", error);
      throw error;
    }
  };

  return { deleteDesignerAccount, loading, error, data };
};
